import React  from 'react'
import MainMenu from '../../components/MainMenu';
import '../../Global/styleGeral.css';
import Calendario from "../../components/Agenda/calendario";


const AgendaPilates = ({history}) => {     
    return (
    <>
      <MainMenu navigation={history} />
      <div>
        <Calendario tipo='pilates' history={history}/>
      </div>
    </>
  );
}

export default AgendaPilates;
